import {Component} from '@angular/core';
import {NgbCarousel, NgbSlide} from '@ng-bootstrap/ng-bootstrap/carousel';
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-gallery-section',
  templateUrl: './gallery-section.component.html',
  styleUrls: ['./gallery-section.component.scss'],
  imports: [NgbCarousel, NgbSlide, NgOptimizedImage]
})
export class GallerySectionComponent {

  previousImageId(i: number, size: number): number {
    const modulo = ((-i % size) + size) % size;
    return size - modulo;
  }

}
